// Elite Games — Interactive behaviors

document.addEventListener('DOMContentLoaded', function () {

  // === Parallax hero on mouse move (all slides) ===
  document.querySelectorAll('.eg-hero').forEach(function (hero) {
    hero.addEventListener('mousemove', function (e) {
      var rect = hero.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      var frame    = hero.querySelector('.eg-hero-art-frame');
      var ring     = hero.querySelector('.eg-hex-ring');
      var art      = hero.querySelector('.eg-hero-art');
      var isTriple = hero.parentElement && hero.parentElement.classList.contains('eg-art-triple');
      if (isTriple) {
        if (art) art.style.transform = 'translate(' + (x * -10) + 'px, ' + (y * -7) + 'px)';
      } else {
        if (frame) frame.style.transform = 'translate(' + (x * -14) + 'px, ' + (y * -10) + 'px)';
        var fig = hero.querySelector('.eg-hero-figure');
        if (fig) fig.style.transform = 'translate(' + (x * 28) + 'px, ' + (y * 20) + 'px)';
      }
      if (ring) ring.style.transform = 'translate(' + (x * 22) + 'px, ' + (y * 16) + 'px)';
    });
    hero.addEventListener('mouseleave', function () {
      var frame = hero.querySelector('.eg-hero-art-frame');
      var ring  = hero.querySelector('.eg-hex-ring');
      var art   = hero.querySelector('.eg-hero-art');
      var fig   = hero.querySelector('.eg-hero-figure');
      if (art)   art.style.transform   = '';
      if (frame) frame.style.transform = '';
      if (ring)  ring.style.transform  = '';
      if (fig)   fig.style.transform   = '';
    });
  });

  // === Parallax banner art on mouse move ===
  document.querySelectorAll('.eg-banner-inner').forEach(function (banner) {
    var art = banner.querySelector('.eg-banner-art');
    if (!art) return;
    banner.addEventListener('mousemove', function (e) {
      var rect = banner.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      var frame = art.querySelector('.eg-controller-frame');
      var img   = art.querySelector('img');
      if (frame) frame.style.transform = 'translate(' + (x * -18) + 'px, ' + (y * -12) + 'px)';
      if (img)   img.style.transform   = 'translate(' + (x * 28) + 'px, ' + (y * 18) + 'px)';
    });
    banner.addEventListener('mouseleave', function () {
      var frame = art.querySelector('.eg-controller-frame');
      var img   = art.querySelector('img');
      if (frame) frame.style.transform = '';
      if (img)   img.style.transform   = '';
    });
  });

  // === Reveal on scroll ===
  const revealEls = document.querySelectorAll('.eg-reveal');
  if (revealEls.length) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('eg-visible');
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  // === Categories active state ===
  document.querySelectorAll('.eg-category').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.eg-category').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // === Smooth scroll for hero CTA ===
  const heroCta = document.querySelector('.eg-hero-cta');
  if (heroCta) {
    heroCta.addEventListener('click', function (e) {
      const target = document.getElementById('eg-ofertas');
      if (target) {
        e.preventDefault();
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
      }
    });
  }

});
